import React from 'react';
import { isNil } from 'ramda';
import { Glyphicon, Button } from 'react-bootstrap';
import RuleCriteria from './rule-criteria';
import ValueReferenceSelector from '../value/value-reference-selector';
import '../../../css/rule/rule.less';

class Rule extends React.Component {

    constructor(props) {
        super(props);
        this.state = { isConfirmDelete: false, listFilter: null };

        this.validateContentTypes = this.validateContentTypes.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onCancelDelete = this.onCancelDelete.bind(this);
        this.onLeftValueChange = this.onLeftValueChange.bind(this);
        this.onRightValueChange = this.onRightValueChange.bind(this);
        this.onCriteriaChange = this.onCriteriaChange.bind(this);
    }

    componentDidMount() {
        let left = manywho.utils.getObjectDataProperty(this.props.objectData.properties, 'leftValueElementToReferenceId');

        // To handle the event where a user has saved a rule
        // without a left value and needs to edit the rule again
        left = left.objectData && left.objectData.length === 1 ? left.objectData[0] : null;

        const criteriaType = manywho.utils.getObjectDataProperty(this.props.objectData.properties, 'criteriaType').contentValue;
        this.setState({ listFilter: this.props.getListFilter(left, criteriaType) });
    }

    onDelete() {
        if (!this.state.isConfirmDelete) {
            this.setState({ isConfirmDelete: true });
        } else {
            this.props.onDelete(this.props.objectData);
        }
    }

    onCancelDelete() {
        this.setState({ isConfirmDelete: false });
    }

    onLeftValueChange(value) {
        const left = manywho.utils.getObjectDataProperty(this.props.objectData.properties, 'leftValueElementToReferenceId');
        left.objectData = value ? [value] : null;

        this.validateContentTypes();

        this.setState({ listFilter: this.props.getListFilter(value, null) });
        this.props.onChange();
    }

    onRightValueChange(value) {
        const right = manywho.utils.getObjectDataProperty(this.props.objectData.properties, 'rightValueElementToReferenceId');
        right.objectData = value ? [value] : null;

        this.validateContentTypes();
        this.props.onChange();
    }

    onCriteriaChange(criteria) {
        manywho.utils.setObjectDataProperty(this.props.objectData.properties, 'CriteriaType', criteria);
        this.validateContentTypes();
        this.setState(
            {
                listFilter: this.props.getListFilter(
                    manywho.utils.getObjectDataProperty(this.props.objectData.properties, 'leftValueElementToReferenceId').objectData[0], criteria,
                ),
            },
        );
        this.props.onChange();
    }

    getContentType(objectData) {
        if (!isNil(objectData)) {
            const parentContentType = manywho.utils.getObjectDataProperty(objectData.properties, 'ParentContentType').contentValue;

            // If the parent is a list we cannot compare to a single instance property so need to compare as a list (all_equal, any_equal etc.)
            // This is a special use case where we need to make a distiction between a list and property of the objects in a list
            // Therefore this cannot match to the standard set of content types
            if (parentContentType === 'ContentList') {
                return 'ContentListProperty';
            }

            // Return content type of selected property
            return manywho.utils.getObjectDataProperty(objectData.properties, 'ContentType').contentValue;
        }

        // Nothing given, so resort to string
        return manywho.component.contentTypes.string;
    }

    validateContentTypes() {
        const left = manywho.utils.getObjectDataProperty(this.props.objectData.properties, 'leftValueElementToReferenceId');
        const right = manywho.utils.getObjectDataProperty(this.props.objectData.properties, 'rightValueElementToReferenceId');
        const criteria = manywho.utils.getObjectDataProperty(this.props.objectData.properties, 'criteriaType').contentValue;

        let leftContentType = null;
        let targetContentType = null;

        if (left.objectData && left.objectData.length === 1) {
            leftContentType = manywho.utils.getObjectDataProperty(left.objectData[0].properties, 'contentType').contentValue;
            targetContentType = leftContentType;
        }

        if (!manywho.utils.isNullOrEmpty(criteria)) {
            targetContentType = manywho.utils.isEqual(criteria, 'IS_EMPTY', true) ? manywho.component.contentTypes.boolean : leftContentType;
        }

        if (right.objectData && right.objectData.length === 1) {
            const rightContentType = manywho.utils.getObjectDataProperty(right.objectData[0].properties, 'contentType').contentValue;
            targetContentType = rightContentType;

            if (!manywho.utils.isEqual(targetContentType, rightContentType, true)) {
                right.objectData = [];
            }
        }
    }

    render() {
        let iconClassName = 'remove-sign';

        if (this.state.isConfirmDelete) {
            iconClassName += ' confirm-delete';
        }

        let left = manywho.utils.getObjectDataProperty(this.props.objectData.properties, 'leftValueElementToReferenceId');
        let right = manywho.utils.getObjectDataProperty(this.props.objectData.properties, 'rightValueElementToReferenceId');

        // To handle when values are removed from the rule
        left = left.objectData && left.objectData.length === 1 ? left.objectData[0] : null;
        right = right.objectData && right.objectData.length === 1 ? right.objectData[0] : null;

        const criteriaType = manywho.utils.getObjectDataProperty(this.props.objectData.properties, 'criteriaType').contentValue;
        const contentType = this.getContentType(left);

        const objectDataRequest = JSON.parse(JSON.stringify(this.props.objectDataRequest));
        objectDataRequest.listFilter = this.state.listFilter;

        return (
            <div className="rule">
                <table>
                    <tbody>
                        <tr>
                            <td className="rule-value-column">
                                <ValueReferenceSelector
                                    value={left}
                                    onChange={this.onLeftValueChange}
                                    objectDataRequest={this.props.objectDataRequest}
                                    flowId={this.props.flowId}
                                    isValid
                                    isEnabled
                                    containerClassName="modal"
                                />
                            </td>
                            <td className="rule-criteria-column">
                                <RuleCriteria contentType={contentType} type={criteriaType} onChange={this.onCriteriaChange} />
                            </td>
                            <td className="rule-value-column">
                                <ValueReferenceSelector
                                    value={right}
                                    onChange={this.onRightValueChange}
                                    objectDataRequest={objectDataRequest}
                                    flowId={this.props.flowId}
                                    isValid
                                    isEnabled
                                    containerClassName="modal"
                                />
                            </td>
                            <td className="rule-delete-column">
                                <Button className="btn-nobackground" onClick={this.onDelete} onBlur={this.onCancelDelete}>
                                    <Glyphicon glyph={iconClassName} />
                                    <div />
                                </Button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                {this.state.isConfirmDelete ? <div className="rule-delete-overlay" /> : null}
            </div>
        );
    }
}

export default Rule;
